<template>
  <span class="input-password">
      <input :type="inputType" :placeholder="$lang.messages.kid.login.pas_placeholder" :value="value" class="form-control" @input="changePassword($event.target.value)" :disabled="disabled">
      <button class="btn-icon" @click="pasVisible = !pasVisible">
        <i class="icon-visible" v-if="pasVisible"></i>
        <i class="icon-hidden" v-if="!pasVisible"></i>
      </button>
    </span>
</template>

<script>

export default {
  name: 'InputPassword',
  props: ['value', 'disabled'],
  data: function () {
    return {
      pasVisible: false,
    }
  },
  computed: {
    inputType (){
      return this.pasVisible ? 'text' : 'password'
    }
  },
  methods: {
    changePassword(value){
      this.$emit('changepassword', value);
    },
  }
}

</script>

<style lang="scss">
.input-password {
  position: relative;
  width: 100%;

  .input {
    margin-bottom: 0;
  }

  .btn-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);

    &:focus {
      outline: none;
    }
  }
}
</style>
